import type React from "react";
import { Spinner as ShadcnSpinner } from "src/shadcn/components/spinner";

const Spinner = (props: React.ComponentProps<typeof ShadcnSpinner>) => (
  <ShadcnSpinner {...props} />
);

export { Spinner };
